import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import {ResidencePermit} from '../../../model/residence-permit';
import {FormatService} from '../../../services/format.service';
import {LocalizedText} from '../../../model/localized-text';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { UnlimitedDatePipe } from '../../../pipes/unlimited-date.pipe';

@Component({
    selector: 'myabvv-permit-residences',
    standalone: true,
    templateUrl: './permit-residences.component.html',
    styleUrls: ['./permit-residences.component.css'],
    imports: [DatePipe, TranslatePipe, UnlimitedDatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitResidencesComponent implements OnInit {
  private formatService = inject(FormatService);


  @Input() residencePermits: ResidencePermit[];

  ngOnInit() {
  }

  getTranslatedData(array: LocalizedText[] | null | undefined): string {
    return this.formatService.getTranslatedData(array);
  }

  isExpired(endDate: string): boolean {
    if (!endDate) return false;
    const end = new Date(endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return end < today;
  }
}
